var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8619 3.86192C13.1223 3.60157 13.5444 3.60157 13.8047 3.86192C14.0451 4.10224 14.0635 4.4804 13.8602 4.74192L13.8047 4.80473L6.4714 12.1381C6.23108 12.3784 5.85293 12.3969 5.5914 12.1935L5.5286 12.1381L2.19526 8.80473C1.93491 8.54438 1.93491 8.12227 2.19526 7.86192C2.43558 7.6216 2.81374 7.60311 3.07527 7.80646L3.13807 7.86192L6 10.7233L12.8619 3.86192Z",
    fill: "#3DBD35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCheckGreen);
export default __webpack_public_path__ + "static/media/icons-check-green.d92c54d9bde067343ed83f85e95f25a6.svg";
export { ForwardRef as ReactComponent };